export default "__VITE_ASSET__3J8XIE16__"